<h4 class="margin">Placeholder</h4>
<div class="card margin">
  <suvo-core-icon-message icon="question_mark" title="Not implemented." message="This is a placeholder."></suvo-core-icon-message>
</div>
<!-- <ng-container *ngIf="dataSourceDefinition">
  <h4 class="margin">{{ dataSourceDefinition.alias }}</h4>
  <div class="card margin">
    <p>{{ dataSourceDefinition | json }}</p>
  </div>
</ng-container> -->